function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import Delaunator from "delaunator";
import Path from "./path.js";
import Polygon from "./polygon.js";
import Voronoi from "./voronoi.js";
var tau = 2 * Math.PI, pow = Math.pow;
function pointX(p) {
    return p[0];
}
function pointY(p) {
    return p[1];
}
// A triangulation is collinear if all its triangles have a non-null area
function collinear(d) {
    var triangles = d.triangles, coords = d.coords;
    for(var i = 0; i < triangles.length; i += 3){
        var a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
        if (cross > 1e-10) return false;
    }
    return true;
}
function jitter(x, y, r) {
    return [
        x + Math.sin(x + y) * r,
        y + Math.cos(x - y) * r
    ];
}
var Delaunay = /*#__PURE__*/ function() {
    "use strict";
    function Delaunay(points) {
        _class_call_check(this, Delaunay);
        this._delaunator = new Delaunator(points);
        this.inedges = new Int32Array(points.length / 2);
        this._hullIndex = new Int32Array(points.length / 2);
        this.points = this._delaunator.coords;
        this._init();
    }
    _create_class(Delaunay, [
        {
            key: "update",
            value: function update() {
                this._delaunator.update();
                this._init();
                return this;
            }
        },
        {
            key: "_init",
            value: function _init() {
                var d = this._delaunator, points = this.points;
                // check for collinear
                if (d.hull && d.hull.length > 2 && collinear(d)) {
                    this.collinear = Int32Array.from({
                        length: points.length / 2
                    }, function(_, i) {
                        return i;
                    }).sort(function(i, j) {
                        return points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1];
                    }); // for exact neighbors
                    var e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                        points[2 * e],
                        points[2 * e + 1],
                        points[2 * f],
                        points[2 * f + 1]
                    ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
                    for(var i = 0, n = points.length / 2; i < n; ++i){
                        var p = jitter(points[2 * i], points[2 * i + 1], r);
                        points[2 * i] = p[0];
                        points[2 * i + 1] = p[1];
                    }
                    this._delaunator = new Delaunator(points);
                } else {
                    delete this.collinear;
                }
                var halfedges = this.halfedges = this._delaunator.halfedges;
                var hull = this.hull = this._delaunator.hull;
                var triangles = this.triangles = this._delaunator.triangles;
                var inedges = this.inedges.fill(-1);
                var hullIndex = this._hullIndex.fill(-1);
                // Compute an index from each point to an (arbitrary) incoming halfedge
                // Used to give the first neighbor of each point; for this reason,
                // on the hull we give priority to exterior halfedges
                for(var e1 = 0, n1 = halfedges.length; e1 < n1; ++e1){
                    var p1 = triangles[e1 % 3 === 2 ? e1 - 2 : e1 + 1];
                    if (halfedges[e1] === -1 || inedges[p1] === -1) inedges[p1] = e1;
                }
                for(var i1 = 0, n2 = hull.length; i1 < n2; ++i1){
                    hullIndex[hull[i1]] = i1;
                }
                // degenerate case: 1 or 2 (distinct) points
                if (hull.length <= 2 && hull.length > 0) {
                    this.triangles = new Int32Array(3).fill(-1);
                    this.halfedges = new Int32Array(3).fill(-1);
                    this.triangles[0] = hull[0];
                    this.triangles[1] = hull[1];
                    this.triangles[2] = hull[1];
                    inedges[hull[0]] = 1;
                    if (hull.length === 2) inedges[hull[1]] = 0;
                }
            }
        },
        {
            key: "voronoi",
            value: function voronoi(bounds) {
                return new Voronoi(this, bounds);
            }
        },
        {
            key: "neighbors",
            value: function neighbors(i) {
                var _this, inedges, hull, _hullIndex, halfedges, triangles, collinear, l, e0, e, p0, p;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this, inedges = _this.inedges, hull = _this.hull, _hullIndex = _this._hullIndex, halfedges = _this.halfedges, triangles = _this.triangles, collinear = _this.collinear;
                            if (!collinear) return [
                                3,
                                5
                            ];
                            l = collinear.indexOf(i);
                            if (!(l > 0)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                collinear[l - 1]
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            if (!(l < collinear.length - 1)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                collinear[l + 1]
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                        case 5:
                            e0 = inedges[i];
                            if (e0 === -1) return [
                                2
                            ]; // coincident point
                            e = e0, p0 = -1;
                            _state.label = 6;
                        case 6:
                            return [
                                4,
                                p0 = triangles[e]
                            ];
                        case 7:
                            _state.sent();
                            e = e % 3 === 2 ? e - 2 : e + 1;
                            if (triangles[e] !== i) return [
                                2
                            ]; // bad triangulation
                            e = halfedges[e];
                            if (!(e === -1)) return [
                                3,
                                10
                            ];
                            p = hull[(_hullIndex[i] + 1) % hull.length];
                            if (!(p !== p0)) return [
                                3,
                                9
                            ];
                            return [
                                4,
                                p
                            ];
                        case 8:
                            _state.sent();
                            _state.label = 9;
                        case 9:
                            return [
                                2
                            ];
                        case 10:
                            if (e !== e0) return [
                                3,
                                6
                            ];
                            _state.label = 11;
                        case 11:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "find",
            value: function find(x, y) {
                var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
                var i0 = i;
                var c;
                while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
                return c;
            }
        },
        {
            key: "_step",
            value: function _step(i, x, y) {
                var _this = this, inedges = _this.inedges, hull = _this.hull, _hullIndex = _this._hullIndex, halfedges = _this.halfedges, triangles = _this.triangles, points = _this.points;
                if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
                var c = i;
                var dc = pow(x - points[i * 2], 2) + pow(y - points[i * 2 + 1], 2);
                var e0 = inedges[i];
                var e = e0;
                do {
                    var t = triangles[e];
                    var dt = pow(x - points[t * 2], 2) + pow(y - points[t * 2 + 1], 2);
                    if (dt < dc) dc = dt, c = t;
                    e = e % 3 === 2 ? e - 2 : e + 1;
                    if (triangles[e] !== i) break; // bad triangulation
                    e = halfedges[e];
                    if (e === -1) {
                        e = hull[(_hullIndex[i] + 1) % hull.length];
                        if (e !== t) {
                            if (pow(x - points[e * 2], 2) + pow(y - points[e * 2 + 1], 2) < dc) return e;
                        }
                        break;
                    }
                }while (e !== e0);
                return c;
            }
        },
        {
            key: "render",
            value: function render(context) {
                var buffer = context == null ? context = new Path : undefined;
                var _this = this, points = _this.points, halfedges = _this.halfedges, triangles = _this.triangles;
                for(var i = 0, n = halfedges.length; i < n; ++i){
                    var j = halfedges[i];
                    if (j < i) continue;
                    var ti = triangles[i] * 2;
                    var tj = triangles[j] * 2;
                    context.moveTo(points[ti], points[ti + 1]);
                    context.lineTo(points[tj], points[tj + 1]);
                }
                this.renderHull(context);
                return buffer && buffer.value();
            }
        },
        {
            key: "renderPoints",
            value: function renderPoints(context) {
                var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
                var buffer = context == null ? context = new Path : undefined;
                var points = this.points;
                for(var i = 0, n = points.length; i < n; i += 2){
                    var x = points[i], y = points[i + 1];
                    context.moveTo(x + r, y);
                    context.arc(x, y, r, 0, tau);
                }
                return buffer && buffer.value();
            }
        },
        {
            key: "renderHull",
            value: function renderHull(context) {
                var buffer = context == null ? context = new Path : undefined;
                var _this = this, hull = _this.hull, points = _this.points;
                var h = hull[0] * 2, n = hull.length;
                context.moveTo(points[h], points[h + 1]);
                for(var i = 1; i < n; ++i){
                    var h1 = 2 * hull[i];
                    context.lineTo(points[h1], points[h1 + 1]);
                }
                context.closePath();
                return buffer && buffer.value();
            }
        },
        {
            key: "hullPolygon",
            value: function hullPolygon() {
                var polygon = new Polygon;
                this.renderHull(polygon);
                return polygon.value();
            }
        },
        {
            key: "renderTriangle",
            value: function renderTriangle(i, context) {
                var buffer = context == null ? context = new Path : undefined;
                var _this = this, points = _this.points, triangles = _this.triangles;
                var t0 = triangles[i *= 3] * 2;
                var t1 = triangles[i + 1] * 2;
                var t2 = triangles[i + 2] * 2;
                context.moveTo(points[t0], points[t0 + 1]);
                context.lineTo(points[t1], points[t1 + 1]);
                context.lineTo(points[t2], points[t2 + 1]);
                context.closePath();
                return buffer && buffer.value();
            }
        },
        {
            key: "trianglePolygons",
            value: function trianglePolygons() {
                var triangles, i, n;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            triangles = this.triangles;
                            i = 0, n = triangles.length / 3;
                            _state.label = 1;
                        case 1:
                            if (!(i < n)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                this.trianglePolygon(i)
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            ++i;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "trianglePolygon",
            value: function trianglePolygon(i) {
                var polygon = new Polygon;
                this.renderTriangle(i, polygon);
                return polygon.value();
            }
        }
    ], [
        {
            key: "from",
            value: function from(points) {
                var fx = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : pointX, fy = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : pointY, that = arguments.length > 3 ? arguments[3] : void 0;
                return new Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
            }
        }
    ]);
    return Delaunay;
}();
export { Delaunay as default };
function flatArray(points, fx, fy, that) {
    var n = points.length;
    var array = new Float64Array(n * 2);
    for(var i = 0; i < n; ++i){
        var p = points[i];
        array[i * 2] = fx.call(that, p, i, points);
        array[i * 2 + 1] = fy.call(that, p, i, points);
    }
    return array;
}
function flatIterable(points, fx, fy, that) {
    var i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, p, err;
    return _ts_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                i = 0;
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    7,
                    8,
                    9
                ]);
                _iterator = points[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    6
                ];
                p = _step.value;
                return [
                    4,
                    fx.call(that, p, i, points)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    fy.call(that, p, i, points)
                ];
            case 4:
                _state.sent();
                ++i;
                _state.label = 5;
            case 5:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 6:
                return [
                    3,
                    9
                ];
            case 7:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    9
                ];
            case 8:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
